<template>
  <div class="page policy-statute">
    <Nav></Nav>
    <v-container class="page-content mt-8 mb-8 px-4 ">
      <router-view></router-view>
    </v-container>
    <CFooter></CFooter>
  </div>
</template>

<script>
import CFooter from '@/components/Common/Footer'
export default {
  components: {
    CFooter
  }
}
</script>

<style lang="scss" scoped>

</style>
